
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 0H0v24h24V0z","fill":"#00C200"}}),_c('path',{attrs:{"d":"M20.71 11.565c.041-.212.061-.391.07-.531a6.662 6.662 0 00-.008-.683c-.213-3.708-4.06-6.662-8.774-6.662-4.852 0-8.784 3.128-8.784 6.986 0 3.547 3.322 6.476 7.627 6.927a.477.477 0 01.423.528l-.183 1.65a.479.479 0 00.685.483c3.636-1.755 5.81-3.56 7.11-5.125.236-.285 1.006-1.364 1.163-1.648a5.879 5.879 0 00.672-1.925z","fill":"#fff"}}),_c('path',{attrs:{"d":"M7.167 12.09V9.149a.45.45 0 00-.898 0v3.392c0 .248.201.45.45.45h1.796a.45.45 0 000-.9H7.167zM9.94 12.99h-.197a.351.351 0 01-.351-.352V9.05c0-.194.157-.351.35-.351h.197c.194 0 .351.157.351.35v3.59a.351.351 0 01-.35.35zM13.57 9.148v2.072s-1.794-2.34-1.822-2.371a.447.447 0 00-.352-.15.462.462 0 00-.432.467v3.374a.45.45 0 00.899 0v-2.06s1.822 2.361 1.848 2.386c.08.076.187.122.304.123.25.002.454-.218.454-.468V9.148a.45.45 0 10-.899 0zM17.838 9.148a.45.45 0 00-.449-.45h-1.797a.45.45 0 00-.45.45v3.392c0 .248.202.45.45.45h1.797a.45.45 0 000-.9h-1.348v-.797h1.348a.45.45 0 000-.898h-1.348v-.798h1.348a.45.45 0 00.45-.449z","fill":"#00C500"}})])
          )
        }
      }
    